"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgeFrontendClient = void 0;
const tslib_1 = require("tslib");
const runtime_1 = require("../runtime");
const bridge_1 = require("@forge/bridge");
const JiraApis_1 = require("../JiraApis");
class ForgeFrontendClient extends JiraApis_1.JiraApis {
    getBackendConfig() {
        return new runtime_1.Configuration({
            basePath: "",
            fetchApi: (url, init) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                return (0, bridge_1.requestJira)(url, 
                // @ts-ignore
                init);
            }),
        });
    }
}
exports.ForgeFrontendClient = ForgeFrontendClient;
const forgeFrontendClient = new ForgeFrontendClient();
exports.default = forgeFrontendClient;
//# sourceMappingURL=forgeFrontendClient.js.map